import React, { useEffect, useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import LoadingSpinner from '../components/common/LoadingSpinner/LoadingSpinner';
import ErrorAlert from '../components/common/ErrorAlert/ErrorAlert';
import { analyticsService } from '../services/analyticsService';
import StatsCard from '../components/Analytics/StatsCard/StatsCard';
import AnalyticsDashboard from '../components/Analytics/AnalyticsDashboard/AnalyticsDashboard';

const LIKE_STATUS_LABELS = {
  invited: 'Отправлено',
  accepted: 'Взаимных',
  rejected: 'Отклонено',
};

const AnalyticsPage = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await analyticsService.getSummary();
        setStats(data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  if (loading && !stats) return <LoadingSpinner />;

  return (
    <>
      <h1 className="mb-3">Аналитика</h1>
      <ErrorAlert error={error} />
      <Row className="g-3 mb-3">
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="Новые регистрации (сегодня)" value={stats?.newRegistrationsToday ?? '-'} />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="Новые регистрации (неделя)" value={stats?.newRegistrationsWeek ?? '-'} />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="DAU" value={stats?.activeUsersToday ?? '-'} />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="Жалобы (сегодня)" value={stats?.complaintsToday ?? '-'} />
        </Col>
      </Row>
      <Row className="g-3 mb-3">
        <Col xs={12} md={6} lg={3}>
          <StatsCard
            title="Начали регистрацию (всего)"
            value={stats?.registrationStartedTotal ?? '-'}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard
            title="Завершили регистрацию (всего)"
            value={
              stats
                ? `${stats.registrationCompletedTotal} · ${stats.registrationCompletionRate}%`
                : '-'
            }
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="Заходов в ленту (сегодня)" value={stats?.feedOpensToday ?? '-'} />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <StatsCard title="Лайков (сегодня)" value={stats?.likesToday ?? '-'} />
        </Col>
      </Row>
      <Row className="g-3">
        <Col xs={12} lg={8}>
          <AnalyticsDashboard stats={stats} />
        </Col>
        <Col xs={12} lg={4}>
          <Card>
            <Card.Body>
              <Card.Title>Быстрый обзор</Card.Title>
              <ul className="mb-2 small">
                <li>Начали регистрацию сегодня: {stats?.registrationStartedToday ?? '-'}</li>
                <li>Завершили регистрацию сегодня: {stats?.registrationCompletedToday ?? '-'}</li>
                <li>Заходов в ленту за неделю: {stats?.feedOpensWeek ?? '-'}</li>
                <li>Заблокировано сегодня: {stats?.blockedToday ?? '-'}</li>
                <li>Матчей создано сегодня: {stats?.matchesToday ?? '-'}</li>
                <li>Сообщений отправлено сегодня: {stats?.messagesToday ?? '-'}</li>
                <li>Первых сообщений сегодня: {stats?.firstMessagesToday ?? '-'}</li>
              </ul>
              <Card.Title className="h6">Лайки</Card.Title>
              <ul className="mb-2 small">
                <li>Всего: {stats?.likesTotal ?? '-'}</li>
                {(stats?.likesByStatus || []).map((row) => (
                  <li key={row.status}>
                    {LIKE_STATUS_LABELS[row.status] || row.status}: {row.count}
                  </li>
                ))}
              </ul>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                «Заходы в ленту» — открытия вкладки. Приложение пока не сообщает
                о прокрутке, поэтому само листание не считается.
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="g-3 mt-1">
        <Col xs={12}>
          <Card>
            <Card.Body>
              <Card.Title>Пользователи по версии приложения и платформе</Card.Title>
              {!stats ? (
                <div className="text-muted small">Загрузка…</div>
              ) : (
                <>
                  {stats.appVersionStats && stats.appVersionStats.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered mb-2">
                        <thead className="table-light">
                          <tr>
                            <th>Платформа</th>
                            <th>Версия</th>
                            <th className="text-end">Пользователей</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stats.appVersionStats.map((row, i) => (
                            <tr key={i}>
                              <td>{row.platform}</td>
                              <td>{row.version}</td>
                              <td className="text-end">{row.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-muted small mb-2">Нет данных о версиях.</div>
                  )}
                  <div className="text-muted small">
                    Без данных о версии / платформе:{' '}
                    <strong>{stats.usersWithoutVersionOrPlatform ?? '-'}</strong>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AnalyticsPage;

